import { Injectable } from '@angular/core';
import { IMediaLibraryHandlerStrategy } from '../../../models/util/mediaLibraryHandlerStrategy';
import { Video } from '../../../models/video';
import { FileUtils } from '../../../utils/fileUtils';
import { MediaLibraryFile } from '../../../enums/mediaLibraryFileType.enum';
import { environment } from '../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class MediaLibraryPdfService implements IMediaLibraryHandlerStrategy {

	private readonly PLACEHOLDER_IMAGE: string = environment.pdfPlaceholderImage;

	type: MediaLibraryFile = MediaLibraryFile.PDF;

	preprocess(file: File): Video {
		const video = new Video();
		video.fileName = file?.name;
		video.fileSize = FileUtils.getMB(file).toFixed(2);
		video.__file = file;
		video.__fileThumbnail = null;
		video.thumbnail = this.PLACEHOLDER_IMAGE;
		video.duration = null;
		video.fileType = this.type;
		return video;
	}

	getThumbnail(media: Video): string {
		return this.PLACEHOLDER_IMAGE;
	}

}
